import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col flex-1 min-h-0 w-full items-center justify-center overflow-hidden">
      <div className="flex flex-col items-center gap-6 text-center px-4">
        <div className="text-[120px] font-black text-[#3D2B90] leading-none select-none">
          404
        </div>
        <h1 className="font-roboto font-black text-[28px] text-[#42445A] uppercase">
          Page Not Found
        </h1>
        <p className="text-[#42445A] text-[16px] font-roboto max-w-[340px]">
          The page you're looking for doesn't exist .
        </p>
        <button
          onClick={() => navigate("/")}
          className="mt-2 px-8 py-3 bg-[#3D2B90] text-white font-roboto font-black text-[16px] uppercase rounded-[67.52px] hover:opacity-90 transition-opacity"
        >
          Go to Chat
        </button>
      </div>
    </div>
  );
};

export default NotFound;
